import { createContext } from 'react'

/**
 * Font metrics for VBar components.
 * These metrics must be evaluated values that can be consumed by CanvasRenderingContext2D.measureText,
 * as they are used for JS-based text clipping.
 */
export interface VBarFontMetrics {
  /** Line height in pixels. Defaults to small text line-height */
  readonly lineHeight?: number
  /** Font size in pixels. Defaults to small text size */
  readonly fontSize?: number
  /** Font family. Defaults to evaluated var(--font-stack-inter) */
  readonly fontFamily?: string
  /** Font weight. Defaults to normal */
  readonly fontWeight?: string
  /** Font style. Defaults to normal */
  readonly fontStyle?: string
  /** Font variant. Defaults to normal */
  readonly fontVariant?: string
}

// Base rem value from GDS
// NOTE: we can make it reactive with RemProvider if needed (see Denali)
const baseRem = 16

/** The default font metrics used by VBars */
export const defaultVBarFontMetrics: Required<VBarFontMetrics> = {
  // text-small line-height from GDS
  lineHeight: 1.2868 * (baseRem - 2),
  // text-small font-size from GDS
  fontSize: 0.86 * (baseRem - 2),
  // From GDS var(--font-stack-inter)
  fontFamily:
    'Inter, -apple-system, "system-ui", "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontVariant: 'normal',
}

/**
 * VBar font metrics context.
 * When provided, VBars will use these metrics when values are not set via regular props.
 */
export const VBarFontMetricsContext = createContext<VBarFontMetrics>(defaultVBarFontMetrics)
